
import classNames from 'classnames';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { Tag } from 'primereact/tag';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FaPlus } from 'react-icons/fa';
import { FaBars } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import AppCard from '../../../../components/appCard';
import AtualizaTemaDialog from '../../../../components/dashboard/topbar/configuracao/atualizaTemaDialog';
import ListaTemasDialog from '../../../../components/dashboard/topbar/configuracao/listaTemas';
import NovoTemaDialog from '../../../../components/dashboard/topbar/configuracao/novoTemaDialog';
import Preview from '../../../../components/dashboard/topbar/configuracao/preview';
import UpdateDeleteDesconto from '../../../../components/dashboard/topbar/configuracao/updateDeleteDesconto';
import UpdateDeleteJuros from '../../../../components/dashboard/topbar/configuracao/updateDeleteJuros';
import UpdateDeleteMulta from '../../../../components/dashboard/topbar/configuracao/updateDeleteMulta';
import UpdateDeleteParcela from '../../../../components/dashboard/topbar/configuracao/updateDeleteParcela';
import { useInfo } from '../../../../context/infoContext';
import { Api } from '../../../../services/api';
import { associado_id, userInfo } from '../../../../services/authHandlers';
import { ButtonPagueDefault, DropdownPague, InputNumberPague, PaginatorPague } from '../../../../styles/primeReactConfig';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { InputMask } from 'primereact/inputmask';
import { validaCnpj, validaCpf } from '../../../../utils/validacoes';
import { mask, unMask, unmask } from 'remask';

function Configuracoes() {

  const { bankList,
    providerInfo,
    setReload,
  } = useInfo();

  const {
    control: control2,
    register: register2,
    handleSubmit: handleSubmit2,
    setValue: setValue2,
  } = useForm({
    c_digital_numero_banco: null,
    c_digital_numero_agencia: null,
    c_digital_conta: null,
  })

  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: {
      pcc_juros_porcentagem: null,
      pcc_id: null,
      pcc_valor_correcao_juros: null,
      pcc_valor_maximo_parcelas: null,
      pcc_valor_minimo_parcela: null,
      pcc_desconto_qtd_parcelas: null,
      pcc_desconto_tipo: null,
      pcc_juros_tipo: null,
      pcc_multa_tipo: null,
      pcc_desconto_valor_juros: null,
      pcc_desconto_valor_multa: null,
      pcc_desconto_valor_original: null,
      pcc_cobranca_fee: null,
      pcc_negociacao_parcial: null,
      pcc_aceita_proposta: null,
      pcc_proposta_closed: null,
    }
  });

  const [loadDesconto, setLoadDesconto] = useState(false);

  const [loadingBank, setLoadingBank] = useState(false);
  const [showUpdateDiscount, setShowUpdateDiscount] = useState(false);
  const [showUpdateJuros, setShowUpdateJuros] = useState(false);
  const [showUpdateMulta, setShowUpdateMulta] = useState(false);
  const [showUpdateDiscountParcela, setShowUpdateParcela] = useState(false);
  const [selectData, setSelectData] = useState();
  const [selectDataJuros, setSelectDataJuros] = useState();
  const [selectDataMulta, setSelectDataMulta] = useState();
  const [selectDataParcela, setSelectDataParcela] = useState();
  const [tipoChave, setTipoChave] = useState('nenhum');
  const [chave,setChave] = useState(null);

  const [create, setCreate] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [corGradiente1, setCorGradiente1] = useState('');
  const [corGradiente2, setCorGradiente2] = useState('');
  const [corGradiente3, setCorGradiente3] = useState('');
  const [corCard1, setCorCard1] = useState('');
  const [corCard2, setCorCard2] = useState('');
  const [corFonte, setCorFonte] = useState('');
  const [corFonte2, setCorFonte2] = useState('ffffff');
  const [corGradienteBotao1, setCorGradienteBotao1] = useState('');
  const [corGradienteBotao2, setCorGradienteBotao2] = useState('');
  const [corBotaoHover1, setCorBotaoHover1] = useState('');
  const [corBotaoHover2, setCorBotaoHover2] = useState('');
  const [textoBotaoCor, setTextoBotaoCor] = useState('ffffff')
  const [corBotaoSombra, setCorBotaoSombra] = useState('');
  const [showLogo, setShowLogo] = useState(true)
  const [showFooter, setShowFooter] = useState(true)
  const [logoDiretoClaro, setLogoDiretoClaro] = useState(true);
  const [corTabelaTitulo, setCorTabelaTitulo] = useState('');
  const [corTabelaConteudo, setCorTabelaConteudo] = useState('');
  const [frontURL, setFrontURL] = useState('');
  const [logoURL, setLogoURL] = useState('');
  const [, setDescricao] = useState('');
  const [providerURL, setProviderURL] = useState('');
  const [themeId, setThemeId] = useState('');
  const [infoTheme, setInfoTheme] = useState([]);
  const [showThemeList, setShowThemeList] = useState(false);
  const [showAddTheme, setShowAddTheme] = useState(false);
  const [showUpdateTheme, setShowUpdateTheme] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [reloadCustomizacao, setReloadCustomizacao] = useState(false);
  const [chaveIncorreta,setChaveIncorreta] = useState(false);

  const [infoQuebraNegociacao, setInfoQuebraNegociacao] = useState({
    status: false,
    juros: null,
    tipoJuros: 'porcentagem',
    multa: null,
    tipoMulta: 'porcentagem',
    diasQuebra: 15,
    update: false,
    exist: false
  });

  useEffect(() => {
    const {
      bancario,
      pcc_info
    } = providerInfo.parametros

    if (pcc_info) {
      setValue('pcc_negociacao_parcial', pcc_info.pcc_negociacao_parcial)
      setValue('pcc_id', pcc_info.pcc_id)
      setValue('pcc_valor_maximo_parcelas', pcc_info.pcc_valor_maximo_parcelas)
      setValue('pcc_valor_minimo_parcela', pcc_info.pcc_valor_minimo_parcela)
      setValue('pcc_valor_correcao_juros', pcc_info.pcc_valor_correcao_juros)
      setValue('pcc_juros_porcentagem', pcc_info.pcc_juros_porcentagem)
      setValue('pcc_desconto_qtd_parcelas', pcc_info.pcc_desconto_qtd_parcelas)
      setValue('pcc_desconto_tipo', pcc_info.pcc_desconto_tipo)
      setValue('pcc_juros_tipo', pcc_info.pcc_juros_tipo)
      setValue('pcc_multa_tipo', pcc_info.pcc_multa_tipo)
      setValue('pcc_desconto_valor_juros', pcc_info.pcc_desconto_valor_juros)
      setValue('pcc_desconto_valor_multa', pcc_info.pcc_desconto_valor_multa)
      setValue('pcc_desconto_valor_original', pcc_info.pcc_desconto_valor_original)
      setValue('pcc_cobranca_fee', pcc_info.pcc_cobranca_fee)
      setValue('pcc_aceita_proposta', pcc_info.pcc_aceita_proposta)
      setValue('pcc_proposta_closed', pcc_info.pcc_proposta_closed)
    }

    if (bancario) {
      setValue2('c_digital_numero_banco', bancario.c_digital_numero_banco)
      setValue2('c_digital_numero_agencia', bancario.c_digital_numero_agencia)
      setValue2('c_digital_conta', bancario.c_digital_conta)
      setChave(bancario.c_digital_chave_pix)
      bancario.c_digital_chave_pix_tipo && setTipoChave(bancario.c_digital_chave_pix_tipo)
    }


  }, [providerInfo?.parametros?.pcc_info])

  useEffect(() => {
    setValue('pcc_desconto_valor_original', getValues('pcc_desconto_valor_original'));
    setValue('pcc_desconto_valor_juros', getValues('pcc_desconto_valor_juros'));
    setValue('pcc_desconto_valor_multa', getValues('pcc_desconto_valor_multa'));
  }, [loadDesconto])

  useEffect(() => {
    async function getCustomizacaoCredor() {
      try {
        const { data } = await Api.get(`customizacaoCredor/listar/${userInfo.usuario_id}`);
        const [tema_ativo] = data.temas.filter((item) => item.customizacao_status === true);
        setInfoTheme(data.temas);
        setCorGradiente1(tema_ativo.cor_gradiente1);
        setCorGradiente2(tema_ativo.cor_gradiente2);
        setCorGradiente3(tema_ativo.cor_gradiente3);
        setCorCard1(tema_ativo.cor_card1);
        setCorCard2(tema_ativo.cor_card2);
        setCorFonte(tema_ativo.cor_fonte);
        setCorFonte2(tema_ativo.cor_fonte_2);
        setCorGradienteBotao1(tema_ativo.gradiente_botao_cor1);
        setCorGradienteBotao2(tema_ativo.gradiente_botao_cor2);
        setCorBotaoHover1(tema_ativo.hover_botao_cor1);
        setCorBotaoHover2(tema_ativo.hover_botao_cor2);
        setTextoBotaoCor(tema_ativo.texto_botao_cor);
        setCorBotaoSombra(tema_ativo.sombra_botao_cor1);
        setShowLogo(tema_ativo.mostrar_logo);
        setShowFooter(tema_ativo.mostrar_footer);
        setLogoDiretoClaro(tema_ativo.logo_direto_claro);
        setCorTabelaTitulo(tema_ativo.cor_tabela_titulo);
        setCorTabelaConteudo(tema_ativo.cor_tabela_conteudo);
        setFrontURL(tema_ativo.front_link);
        setLogoURL(tema_ativo.logo_link);
        setDescricao(tema_ativo.descricao);
        setProviderURL(tema_ativo.customizacao_url_credor);
      } catch (error) {
        console.log(error.response)
      }
    }
    async function getPremium() {
      try {
        const { data } = await Api.get(`/customizacaoCredor/consultarPlano/${userInfo.usuario_id}`);
        const { plano_premium: { plano_status } } = data;
        setIsPremium(plano_status);
      } catch (error) {
        console.log(error.response);
      }
    }
    getPremium()
    getCustomizacaoCredor()
  }, [reloadCustomizacao])

  useEffect(() => {
    async function parametrosQuebraAcordo() {
      try {

        const { data } = await Api.get(`/quebranegociacao/parametros/buscar`)
        setInfoQuebraNegociacao(prev => ({
          ...prev,
          status: data.parametros_status,
          juros: data.juros,
          tipoJuros: data.juros_tipo,
          multa: data.multa,
          tipoMulta: data.multa_tipo,
          diasQuebra: data.dias_vencimento,
          exist: data.exist
        }))
      } catch (error) {
        console.log(error.response)
      }
    }
    parametrosQuebraAcordo()
  }, [false])

  // chamada de api

  const addBankAccount = async (values) => {

    setLoadingBank(true);
    try {
      let chave_pix = unmask(chave)
      if(!validaChave(chave) && tipoChave !== 'nenhum'){
        toast.error('Chave informada inválida')
        return null 
      }
      if(tipoChave === 'celular'){
        chave_pix = '+55'+chave_pix 
      }
      console.log(chave_pix)
      await Api.post('/contadigital/cadastrar', {
        usuario_id: userInfo.usuario_id,
        c_digital_numero_banco: values.c_digital_numero_banco,
        c_digital_numero_agencia: values.c_digital_numero_agencia,
        c_digital_conta: values.c_digital_conta,
        c_digital_chave_pix: tipoChave !== 'nenhum' ? chave_pix : null,
        c_digital_chave_pix_tipo: tipoChave !== 'nenhum' ? tipoChave : null
      })
      toast.success('Conta bancária cadastrada com sucesso!');
    } catch (error) {
      console.log(error.response);
      toast.error('Erro ao cadastrar conta bancária');
    } finally {
      setLoadingBank(false);
    }
  }

  const updateParams = async (values) => {
    const associado_operador_id = userInfo.associado_id || associado_id;

    const params = {
      ...values,
      associado_id: associado_operador_id
    }

    if (values.pcc_valor_minimo_parcela < 30) {
      toast.error('Valor menor que R$ 30')
      return
    }

    toast.info('Atualizando parâmetros...')
    try {
      if (!values.pcc_id) {
        await Api.post('parametrizacaoproviders/insereParametros', params)
      }
      else {
        await Api.put('parametrizacaoproviders/atualizaParametros', params)
      }
      setReload(prevReload => !prevReload);
      toast.success('Parâmetros definidos com sucesso');
    } catch (err) {
      toast.error('Erro ao definir parâmetros de parcelamento');
      console.error(err);
    }
  }

  const quebraNegocicacaoParams = async (event) => {
    event.preventDefault()

    const associado_operador_id = userInfo.associado_id || associado_id
    const parametros_status = infoQuebraNegociacao.status;
    const juros = infoQuebraNegociacao.juros > 100 ? 100 : infoQuebraNegociacao.juros;
    const multa = infoQuebraNegociacao.multa > 100 ? 100 : infoQuebraNegociacao.multa;
    const juros_tipo = infoQuebraNegociacao.tipoJuros;
    const multa_tipo = infoQuebraNegociacao.tipoMulta;
    const dias_vencimento = infoQuebraNegociacao.diasQuebra;
    if (dias_vencimento > 145 || dias_vencimento < 15) {
      toast.error('Dias após o vencimento só podem ser a partir de 15 dias até 145 dias.')
      return;
    }

    const params = { parametros_status, juros, juros_tipo, multa, multa_tipo, dias_vencimento, associado_id: associado_operador_id }
    toast.info('Atualizando parâmetros...')
    try {
      if (!infoQuebraNegociacao.exist) {
        await Api.post('/quebranegociacao/parametros/adicionar', params);
        setInfoQuebraNegociacao(prev => ({ ...prev, exist: true }))
      }
      else {
        await Api.put('/quebranegociacao/parametros/atualizar', params);
      }
      setReload(prevReload => !prevReload);
      toast.success('Parâmetros definidos com sucesso');
    } catch (err) {
      toast.error('Erro ao definir parâmetros de quebra de acordo');
      console.error(err);
    }
  }

  const activateTheme = async () => {
    try {
      await Api.post('customizacaoCredor/ativar', { tema_id: themeId });
      setReloadCustomizacao(prevReload => !prevReload);
      toast.success('Tema ativado com sucesso!');
    } catch (error) {
      console.log(error.response)
      toast.error('Erro ao ativar tema');
    }
  }

  // functions

  const HandleSelection = (rowData) => {
    setSelectData(rowData);
    setShowUpdateDiscount(true);
    setCreate(false);
  }

  const HandleSelectionParcela = (rowData) => {
    setSelectDataParcela(rowData);
    setCreate(false)
    setShowUpdateParcela(true);
  }

  const HandleSelectionJuros = (rowData) => {
    setSelectDataJuros(rowData);
    setCreate(false)
    setShowUpdateJuros(true);
  }

  const HandleSelectionMulta = (rowData) => {
    setSelectDataMulta(rowData);
    setCreate(false)
    setShowUpdateMulta(true);
  }

  async function selectTheme(data) {
    setCorGradiente1(data.cor_gradiente1);
    setCorGradiente2(data.cor_gradiente2);
    setCorGradiente3(data.cor_gradiente3);
    setCorCard1(data.cor_card1);
    setCorCard2(data.cor_card2);
    setCorFonte(data.cor_fonte);
    setCorFonte2(data.cor_fonte_2);
    setCorGradienteBotao1(data.gradiente_botao_cor1);
    setCorGradienteBotao2(data.gradiente_botao_cor2);
    setCorBotaoHover1(data.hover_botao_cor1);
    setCorBotaoHover2(data.hover_botao_cor2);
    setTextoBotaoCor(data.texto_botao_cor);
    setCorBotaoSombra(data.sombra_botao_cor1);
    setShowFooter(data.mostrar_footer);
    setShowLogo(data.mostrar_logo);
    setLogoDiretoClaro(data.logo_direto_claro);
    setCorTabelaTitulo(data.cor_tabela_titulo);
    setCorTabelaConteudo(data.cor_tabela_conteudo);
    setFrontURL(data.front_link);
    setLogoURL(data.logo_link);
    setDescricao(data.descricao);
    setThemeId(data.customizacao_credor_id);
  }

  // formatação

  function formatPercentage(amount) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'percent',
    }).format(amount / 100);
  }

  // template

  const bankItems = bankList.map((i) => (
    {
      label: i.fullName,
      value: i.code !== null ? String(i.code).padStart(3, '0') : null,
      className: classNames(i.code === null ? ('hidden') : (''))
    }
  ));

  const chaveItems = [
    {label:'Nenhum', value:'nenhum'},
    {label:'CPF', value:'cpf'}, 
    {label:'CNPJ', value:'cnpj'},
    {label:'Email', value:'email'}, 
    {label:'Celular', value:'celular'}, 
    {label:'Chave Aleatória', value:'chave_aleatoria'}
  ]

  const headerParcelamento = (
    <div className='flex justify-between'>
      <div>
        <h5>Parâmetro de parcelamento por faixa de valor</h5>
      </div>
      <div>
        <Button
          icon={<FaPlus />}
          severity='success'
          type="button"
          onClick={() => { setShowUpdateParcela(true); setCreate(true) }} />
      </div>
    </div>
  )


  const headerDesconto = (
    <div className='flex justify-between'>
      <div>
        <h5>Parâmetro de desconto por faixa de valor</h5>
        <p className='text-sm font-normal'>Para adição deste parâmetro, é obrigatória a escolha da aplicação de desconto (Valor Original/Juros/Multa).</p>
      </div>
      <div>
        <Button
          icon={<FaPlus />}
          severity='success'
          type="button"
          onClick={() => { setShowUpdateDiscount(true); setCreate(true) }}
          disabled={!(getValues('pcc_desconto_valor_original') || getValues('pcc_desconto_valor_juros') || getValues('pcc_desconto_valor_multa'))}
        />
      </div>
    </div>
  )

  const headerJuros = (
    <div className='flex justify-between'>
      <div>
        <h5>Juros por faixa de valor</h5>
      </div>
      <div>
        <Button
          icon={<FaPlus />}
          severity='success'
          type="button"
          onClick={() => { setShowUpdateJuros(true); setCreate(true) }} />
      </div>
    </div>
  )

  const headerMulta = (
    <div className='flex justify-between'>
      <div>
        <h5>Multa por faixa de valor</h5>
      </div>
      <div>
        <Button
          icon={<FaPlus />}
          severity='success'
          type="button"
          onClick={() => { setShowUpdateMulta(true); setCreate(true) }} />
      </div>
    </div>
  )

  const validaChave = (e) => {
    switch (tipoChave) {
      case 'cpf':
        return validaCpf(e)
      case 'cnpj':
        return validaCnpj(e)
      case 'celular':       
        return unmask(e).length === 11
      case 'email':
        return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(e)
      case 'chave_aleatoria':
        return true
      case 'nenhum':
        return true
      default:
        return false
    }
  }

  const maskOptions = () => {
    switch (tipoChave) {
      case 'cpf':
        return "999.999.999-99"
      case 'cnpj':
        return "99.999.999/9999-99"
      case 'celular':       
        return "(99) 99999-9999"
      case 'email':
        return ""
      case 'chave_aleatoria':
        return ""
      case 'nenhum':
        return ""
      default:
        return null
    }
  }
  const maskMiddleware = (value) => {
    switch (tipoChave) {
      case 'cpf':
        return mask(unMask(value), [maskOptions(tipoChave)])
      case 'cnpj':
        return mask(unMask(value), [maskOptions(tipoChave)])
      case 'celular':       
        return mask(unMask(value), [maskOptions(tipoChave)])
      case 'email':
        return value
      case 'chave_aleatoria':
        return value
      case 'nenhum':
        return null
      default:
        return null
    }
  }
  const placeholderOptions = (e) => {
    switch (tipoChave) {
      case 'cpf':
        return "999.999.999-99"
      case 'cnpj':
        return "99.999.999/9999-99"
      case 'celular':       
        return "(99) 99999-9999"
      case 'email':
        return "direto@direto.tech"
      case 'chave_aleatoria':
        return "6589502e-f8eb-4caf-9c2e-0fbd80bc74c8"
      case 'nenhum':
        return null
      default:
        return null
    }
  }


  const tagStatusQuebra = () => {
    let corTag = 'danger'
    let valorTexto = 'Inativo'
    if (infoQuebraNegociacao.status) { corTag = 'success'; valorTexto = 'Ativo'; }
    if (!infoQuebraNegociacao.status) { corTag = 'danger'; valorTexto = 'Inativo'; }
    return <Tag className="transition-all duration-300 text-align-center w-full" severity={corTag} value={<p style={{ fontSize: '14px' }}>{valorTexto}</p>} rounded></Tag>
  }

  return (
    <div className='grid'>

      {showUpdateDiscount &&
        <UpdateDeleteDesconto
          pccID={providerInfo.parametros.pcc_info.pcc_id}
          create={create}
          close={() => setShowUpdateDiscount(false)}
          infoParam={selectData}
          reload={() => updateParams(getValues())} />}
      {showUpdateDiscountParcela &&
        <UpdateDeleteParcela
          create={create}
          close={() => setShowUpdateParcela(false)}
          infoParam={selectDataParcela}
          reload={() => updateParams(getValues())} />}
      {showUpdateJuros &&
        <UpdateDeleteJuros
          create={create}
          close={() => setShowUpdateJuros(false)}
          infoParam={selectDataJuros}
          reload={() => setReload(prevReload => !prevReload)} />}
      {showUpdateMulta &&
        <UpdateDeleteMulta
          create={create}
          close={() => setShowUpdateMulta(false)}
          infoParam={selectDataMulta}
          reload={() => setReload(prevReload => !prevReload)} />}
      {showThemeList &&
        <ListaTemasDialog
          close={() => setShowThemeList(false)}
          themeList={infoTheme}
          selectTheme={(e) => selectTheme(e.value)}
          reload={() => setReloadCustomizacao(prevReload => !prevReload)}
          updateTheme={(e) => { setUpdateData(e); setShowUpdateTheme(true) }}
        />
      }
      {showAddTheme &&
        <NovoTemaDialog
          close={() => setShowAddTheme(false)}
          providerURL={providerURL}
          reload={() => setReloadCustomizacao(prevReload => !prevReload)}
        />
      }
      {showUpdateTheme &&
        <AtualizaTemaDialog
          close={() => setShowUpdateTheme(false)}
          providerURL={providerURL}
          reload={() => setReloadCustomizacao(prevReload => !prevReload)}
          themeData={updateData}
        />
      }
      <div className='w-full flex flex-wrap [&>span:has(>input:focus)~label]:mt-0'>

        <div className='w-full md:w-1/2 grid gap-4 px-2'>
          <AppCard >
            <div className="grid w-full gap-6">
              <div className='text-xl'>
                <h4><b>Informações Bancárias</b></h4>
              </div>
              <form onSubmit={handleSubmit2(addBankAccount)}>
                <div className="px-3 grid gap-4">
                  <div className="flex flex-wrap justify-between">
                    <label htmlFor="c_digital_numero_banco">
                      <b>Banco</b>
                    </label>
                    <Controller
                      name="c_digital_numero_banco"
                      control={control2}
                      defaultValue={null}
                      rules={{ required: true }}
                      render={({ field: { name, onChange, value } }) => (
                        <Dropdown
                          value={value}
                          onChange={(e) => { onChange(e); setValue2("c_digital_numero_banco", e.value) }}
                          id={name}
                          options={bankItems}
                          optionLabel="label"
                          optionValue='value'
                          filter
                          filterBy='label'
                          showFilterClear
                          filterInputAutoFocus
                          focusOnHover={false}
                          scrollHeight='30em'
                          className='painelAdimplencia'
                          pt={DropdownPague}
                        />)}
                    />
                  </div>

                  <div className="flex flex-wrap justify-between">
                    <div>
                      <label htmlFor="c_digital_numero_banco"><b>
                        Código do Banco</b>
                      </label>
                      <p>Com os zeros a esquerda</p>
                    </div>
                    <InputText
                      {...register2("c_digital_numero_banco",
                        {
                          required: true,
                        })}
                      placeholder="(ex: 9999)"
                    />
                  </div>

                  <div className="flex flex-wrap justify-between ">
                    <label htmlFor="c_digital_numero_agencia"><b>
                      Número da agência bancária</b>
                    </label>
                    <div>
                      <Controller
                        name="c_digital_numero_agencia"
                        control={control2}
                        defaultValue={null}
                        rules={{ required: true }}
                        render={({ field: { onChange, onBlur, value, name } }) => (
                          <InputNumber
                            id={name}
                            placeholder="(ex: 9999)"
                            onBlur={onBlur}
                            onChange={e => onChange(e.value)}
                            value={value}
                            pt={InputNumberPague}
                            required
                            min={0}
                            useGrouping={false}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap justify-between ">
                    <div className="">
                      <label htmlFor="c_digital_conta"><b>
                        Número da Conta</b>
                      </label>
                      <p>Com o digito verificador, sem os zeros a esquerda</p>
                    </div>
                    <div className="">
                      <Controller
                        name="c_digital_conta"
                        control={control2}
                        defaultValue={null}
                        rules={{ required: true }}
                        render={({ field: { onChange, onBlur, value, name } }) => (
                          <InputNumber
                            id={name}
                            placeholder="(ex: 99999999)"
                            onBlur={onBlur}
                            onChange={e => onChange(e.value)}
                            value={value}
                            pt={InputNumberPague}
                            required
                            min={0}
                            useGrouping={false}
                          />)}
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap justify-between">
                    <label htmlFor="c_digital_chave_pix"><b>
                      Chave Pix (opcional)</b>
                    </label>
                  </div>
                  <div className="flex flex-wrap justify-between">
                    <Dropdown
                      value={tipoChave}
                      onChange={(e) => { setChave("");setTipoChave(e.value) }}
                      id={'tipo_chave'}
                      options={chaveItems}
                      optionLabel='label'
                      optionValue='value'
                      //focusOnHover={false}
                      className='painelAdimplencia'
                      pt={DropdownPague}
                    />
                    <div className='grid'>
                      {tipoChave !== "nenhum" &&
                        <InputText
                        value={chave}
                        onChange= {({ target:{value} })=>{setChave(maskMiddleware(value))}}
                        placeholder={`ex: ${placeholderOptions(tipoChave)}`}
                        type='text'
                        id='chave_pix'
                        // mask='999.999.999-99'
                        />
                      }
                    </div>
                  </div>
                  <div className="w-full flex justify-center mt-4">
                    <div className=" w-full md:w-7/12 ">
                      <Button
                        pt={ButtonPagueDefault}
                        label="Salvar"
                        type="submit"
                        loading={loadingBank}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </AppCard>

          <AppCard>
            <div className="w-full">
              <form onSubmit={handleSubmit(updateParams)}>
                <h4 className='text-xl'><b>Desconto</b></h4>
                <div className="px-3">
                  <div className='grid mt-5'>
                    <div className='w-full '>
                      <label><b>O desconto deverá ser aplicado sobre qual valor?</b></label>
                      <p>Para aplicar sobre o valor corrigido, marque todas as opções abaixo</p>
                    </div>
                    <div className='w-full flex flex-wrap mt-6 px-3 justify-between '>
                      <div className=" ">
                        <Controller
                          name="pcc_desconto_valor_original"
                          control={control}
                          defaultValue={false}
                          render={({ field: { name, value, onChange } }) => (
                            <Checkbox
                              inputId={name}
                              checked={value}
                              onChange={e => {
                                onChange(e.checked);
                                setLoadDesconto(prev => !prev);
                              }} />
                          )}
                        />
                        <label htmlFor="VOriginal"> Valor Original</label>
                      </div>
                      <div className=" ">
                        <Controller
                          name="pcc_desconto_valor_juros"
                          control={control}
                          defaultValue={false}
                          render={({ field: { name, value, onChange } }) => (
                            <Checkbox
                              inputId={name}
                              checked={value}
                              onChange={e => {
                                onChange(e.checked);
                                setLoadDesconto(prev => !prev);
                              }} />
                          )}
                        />
                        <label htmlFor="Juros"> Juros</label>
                      </div>
                      <div className=" ">
                        <Controller
                          name="pcc_desconto_valor_multa"
                          control={control}
                          defaultValue={false}
                          render={({ field: { name, value, onChange } }) => (
                            <Checkbox
                              inputId={name}
                              checked={value}
                              onChange={e => {
                                onChange(e.checked);
                                setLoadDesconto(prev => !prev);
                              }} />
                          )}
                        />
                        <label htmlFor="Multa"> Multa</label>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row justify-between mt-5">
                    <div className="w-9/12">
                      <label htmlFor="desconto_qtd_max"><b>
                        Máximo de parcelas para desconto </b>
                      </label>
                      <p>O desconto deverá ser aplicado em até quantas parcelas?</p>
                    </div>
                    <div className="w-3/12">
                      <Controller
                        name="pcc_desconto_qtd_parcelas"
                        control={control}
                        defaultValue={null}
                        render={({ field: { name, value, onChange, onBlur } }) => (
                          <InputNumber
                            id={name}
                            pt={InputNumberPague}
                            onBlur={onBlur}
                            onChange={e => onChange(e.value)}
                            value={value}
                            max={50}
                            min={0}
                            locale="pt-BR"
                            mode="decimal"
                            suffix=' x'
                            placeholder='ex: 1 x'
                            required
                          />)}
                      />
                    </div>
                  </div>
                  <div className='mt-4'>
                    <DataTable
                      value={providerInfo.parametros.desconto}
                      header={headerDesconto}
                      pt={{
                        paginator: PaginatorPague
                      }}
                      onSelectionChange={(e) => HandleSelection(e.value)}
                      selectionMode="single"
                      emptyMessage="Nenhum desconto cadastrado!"
                      paginator
                      rows={5}
                    >
                      <Column field="valor_inicial" body={rowData => formatCurrency(Number(rowData.valor_inicial))} header="Valor Inicial" />
                      <Column field="valor_final" body={rowData => formatCurrency(Number(rowData.valor_final))} header="Valor Final" />
                      <Column field="valor_desconto" body={rowData => formatPercentage(rowData.valor_desconto)} header="Valor do Desconto" />
                    </DataTable>
                  </div>
                  <div className="w-full flex justify-center mt-5">
                    <div className="w-full md:w-7/12 ">
                      <Button
                        pt={ButtonPagueDefault}
                        label="Salvar"
                        type="submit"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </AppCard>

          <AppCard>
            <div className="grid w-full">
              <form onSubmit={(e) => quebraNegocicacaoParams(e)}>
                <h4 className='text-xl'><b>Quebra de acordo (Inadimplência)</b></h4>
                <div className='px-3 w-full mt-4'>
                  <label><b>O que é uma quebra de acordo?</b></label>
                  <p>Tempo definido para uma nova negociação, mediante quebra de acordo por não pagamento de negociação já realizada.</p>
                </div>
                <div className="px-3 w-full mt-3 grid gap-4">
                  <div className='grid-cols-3 grid w-full'>
                    <div className="w-full">
                      <label htmlFor="status_quebra_cob">
                        <b>Status</b>
                      </label>
                    </div>
                    <div className='justify-between flex w-full'>
                      {tagStatusQuebra()}
                    </div>
                    <div className="ml-4">
                      <InputSwitch
                        pt={{
                          slider: ({ props }) => ({
                            className: classNames(
                              'absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent',
                              'transition-colors duration-200 rounded-2xl',
                              'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                              "before:absolute before:content-'' before:top-1/2 before:bg-white before:dark:bg-gray-900 before:w-5 before:h-5 before:left-1 before:-mt-2.5 before:rounded-full before:transition-duration-200",
                              {
                                'bg-gray-400 dark:bg-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 ': !props.checked,
                                'bg-sky-400 before:transform before:translate-x-5': props.checked
                              }
                            )
                          })
                        }}
                        checked={infoQuebraNegociacao.status}
                        onChange={(e) => setInfoQuebraNegociacao(prev => ({ ...prev, status: e.value }))}
                      />
                    </div>
                  </div>

                  <div className='grid grid-cols-3 w-full'>
                    <div className="w-full">
                      <label htmlFor="juros_quebra_cob">
                        <b>Juros</b>
                        <p>Porcentagem/mês</p>
                      </label>
                    </div>
                    <div className="grid w-full">
                      <InputNumber
                        id="valor_juros_quebra"
                        name="valor_juros_quebra"
                        placeholder="ex: 1% " suffix='%'
                        pt={InputNumberPague}
                        value={infoQuebraNegociacao.juros}
                        onChange={(e) => setInfoQuebraNegociacao(prev => ({ ...prev, juros: e.value }))}
                        required
                        locale="pt-BR"
                        mode="decimal"
                        min={0} max={100}
                        disabled={!infoQuebraNegociacao.status}
                      />
                    </div>
                  </div>

                  <div className='grid grid-cols-3 w-full'>
                    <div className="w-full">
                      <label htmlFor="multa_quebra_cob">
                        <b>Multa</b>
                        <p>Porcentagem/mês</p>
                      </label>
                    </div>
                    <div className="w-full">
                      <InputNumber
                        id="valor_multa_quebra"
                        name="valor_multa_quebra"
                        placeholder="ex: 1% "
                        pt={InputNumberPague}
                        suffix='%'
                        value={infoQuebraNegociacao.multa}
                        onChange={(e) => setInfoQuebraNegociacao(prev => ({ ...prev, multa: e.value }))}
                        required
                        locale="pt-BR"
                        mode="decimal"
                        min={0} max={100}
                        disabled={!infoQuebraNegociacao.status}
                      />
                    </div>
                  </div>

                  <div className='grid grid-cols-3 w-full'>
                    <div className="w-full">
                      <label htmlFor="dias_quebra_cob">
                        <b>Dias após o vencimento</b>
                      </label>
                      <p>Até sinalizar a quebra de acordo</p>
                    </div>
                    <div className="w-full flex flex-col">
                      <InputNumber
                        id="valor_juros_quebra"
                        name="valor_juros_quebra"
                        placeholder="ex: 60 (dias)"
                        pt={InputNumberPague}
                        value={infoQuebraNegociacao.diasQuebra}
                        onChange={e => setInfoQuebraNegociacao(prev => ({ ...prev, diasQuebra: e.value }))}
                        locale="pt-BR"
                        mode="decimal"
                        disabled={!infoQuebraNegociacao.status}
                        required
                      />
                      <label className='text-xs font-semibold'>
                        Menor valor: 15; Maior valor: 145.
                      </label>
                    </div>
                  </div>
                  <div className="w-full flex justify-center mt-2">
                    <div className="p-fluid w-full md:w-7/12 ">
                      <Button
                        pt={ButtonPagueDefault}
                        label="Salvar"
                        type="submit"
                      ></Button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </AppCard>

          {(userInfo.usuario_id === '092ae679-4556-4408-b372-ad23b4ed8216'
            || isPremium)
            &&
            <AppCard className='overflow-auto'>
              <div className='w-full grid'>
                <div className='flex justify-between w-full'>
                  <div>
                    <h4 className='text-xl'><b>Layout plataforma de negociação</b></h4>
                  </div>
                  <div>
                    <Button
                      icon={<FaPlus />}
                      severity='success'
                      type="button"
                      onClick={() => { setShowAddTheme(true); }} />
                  </div>
                </div>
                <Preview config={{
                  corGradiente1,
                  corGradiente2,
                  corGradiente3,
                  corCard1,
                  corCard2,
                  corFonte,
                  corFonte2,
                  corGradienteBotao1,
                  corGradienteBotao2,
                  corBotaoHover1,
                  corBotaoHover2,
                  textoBotaoCor,
                  corBotaoSombra,
                  logoURL,
                  frontURL,
                  showLogo,
                  showFooter,
                  corTabelaTitulo,
                  corTabelaConteudo,
                  logoDiretoClaro,
                }} />
                <div className="w-full flex justify-between mt-5">
                  <div className="grid w-full md:w-5/12 ">
                    <Button
                      pt={ButtonPagueDefault}
                      label="Salvar"
                      type="button"
                      onClick={() => activateTheme()}
                    ></Button>
                  </div>
                  <div className="grid w-full md:w-5/12 ">
                    <Button
                      severity='info'
                      label="Lista"
                      icon={<FaBars />}
                      type="button"
                      onClick={() => { setShowThemeList(true) }}
                    ></Button>
                  </div>
                </div>
              </div>
            </AppCard>}
        </div>
        <div className='w-full md:w-1/2 px-2 md:mt-0 mt-4'>
          <AppCard>
            <div className="grid w-full">
              <form onSubmit={handleSubmit(updateParams)}>
                <h4 className='text-xl'><b>Parâmetros</b></h4>
                <div className="gap-3 grid px-3 mt-3">
                  <h4 className='text-xl'><b>Juros</b></h4>
                  <div className='w-full'>
                    <label><b>O juros deverá ser aplicado como porcentagem ou valor monetário?</b></label>
                    <p>O valor do juros pode ser configurado na tabela abaixo para uma faixa de valor</p>
                  </div>

                  <Controller
                    name="pcc_juros_tipo"
                    control={control}
                    defaultValue={null}
                    rules={{ required: true }}
                    render={({ field: { ...props } }) => (
                      <div className='w-full flex justify-evenly '>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value="porcento"
                            checked={props.value === "porcento"}
                          />
                          <label htmlFor="porcentagem">Porcentagem/mês</label>
                        </div>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value="valor"
                            checked={props.value === "valor"}
                          />
                          <label htmlFor="Valor">Valor/dia</label>
                        </div>
                      </div>
                    )}
                  />

                  <div className='mt-2 config-tables w-full'>
                    <DataTable
                      value={providerInfo.parametros.juros}
                      header={headerJuros}
                      pt={{
                        paginator: PaginatorPague
                      }}
                      onSelectionChange={(e) => HandleSelectionJuros(e.value)}
                      selectionMode="single"
                      emptyMessage="Nenhuma taxa de juros cadastrado!"
                      className='config-tables'
                      paginator
                      rows={5}
                    >
                      <Column field="pccj_inicio" body={rowData => formatCurrency(Number(rowData.pccj_inicio))} header="Valor Inicial" />
                      <Column field="pccj_final" body={rowData => formatCurrency(Number(rowData.pccj_final))} header="Valor Final" />
                      <Column field="pccj_valor_juros"
                        header="Juros" />
                    </DataTable>
                  </div>

                  <h4 className='text-xl'><b>Multa</b></h4>
                  <div className='w-full'>
                    <label><b>A multa deverá ser aplicada como porcentagem ou valor monetário?</b></label>
                    <p>O valor da multa pode ser configurado na tabela abaixo para uma faixa de valor</p>
                  </div>

                  <Controller
                    name="pcc_multa_tipo"
                    control={control}
                    defaultValue={null}
                    rules={{ required: true }}
                    render={({ field: { ...props } }) => (
                      <div className='w-full flex justify-evenly '>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value="porcento"
                            checked={props.value === "porcento"}
                          />
                          <label htmlFor="multa_porcentagem">Porcentagem</label>
                        </div>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value="valor"
                            checked={props.value === "valor"}
                          />
                          <label htmlFor="multa_valor">Valor</label>
                        </div>
                      </div>
                    )}
                  />

                  <div className='mt-2 config-tables w-full'>
                    <DataTable
                      value={providerInfo.parametros.multa}
                      header={headerMulta}
                      pt={{
                        paginator: PaginatorPague
                      }}
                      onSelectionChange={(e) => HandleSelectionMulta(e.value)}
                      selectionMode="single"
                      emptyMessage="Nenhuma multa cadastrada!"
                      className='config-tables'
                      paginator
                      rows={5}
                    >
                      <Column field="pccm_inicio" body={rowData => formatCurrency(Number(rowData.pccm_inicio))} header="Valor Inicial" />
                      <Column field="pccm_final" body={rowData => formatCurrency(Number(rowData.pccm_final))} header="Valor Final" />
                      <Column field="pccm_valor_multa"
                        header="Multa" />
                    </DataTable>
                  </div>
                </div>
                {getValues('pcc_cobranca_fee') !== 'nenhum' &&
                  <div className='grid gap-2 mt-4 px-3'>
                    <h4 className='text-xl'><b>Cobrança da taxa da Direto</b></h4>
                    <div className='w-full '>
                      <label><b>Quem deverá pagar a taxa da Direto?</b></label>
                      <p>Empresa (credor) ou Devedor</p>
                    </div>
                    <Controller
                      name="pcc_cobranca_fee"
                      control={control}
                      defaultValue={null}
                      rules={{ required: true }}
                      render={({ field: { ...props } }) => (
                        <div className='w-full flex justify-evenly '>
                          <div className='flex gap-2'>
                            <RadioButton
                              {...props}
                              value="credor"
                              checked={props.value === "credor"}
                            />
                            <label htmlFor="credor">Empresa (credor)</label>
                          </div>
                          <div className='flex gap-2'>
                            <RadioButton
                              {...props}
                              value="devedor"
                              checked={props.value === "devedor"}
                            />
                            <label htmlFor="devedor">Devedor</label>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                }
                <div className='grid gap-2 mt-4 px-3'>
                  <h4 className='text-xl'><b>Negociação Parcial</b></h4>
                  <div className='w-full '>
                    <label><b>Deseja permitir negociação parcial?</b></label>
                    <p>Negociação parcial é o tipo de negociação onde o devedor negocia apenas parte de seus débitos</p>
                  </div>
                  <Controller
                    name="pcc_negociacao_parcial"
                    control={control}
                    defaultValue={null}
                    rules={{ required: false }}
                    render={({ field: { ...props } }) => (
                      <div className='w-full flex justify-evenly '>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value={true}
                            checked={props.value}
                          />
                          <label htmlFor="aceita_parcial">Sim</label>
                        </div>
                        <div className='flex gap-2'>
                          <RadioButton
                            {...props}
                            value={false}
                            checked={!props.value}
                          />
                          <label htmlFor="rejeita_parcial">Não</label>
                        </div>
                      </div>
                    )}
                  />
                </div>
                <div className='px-3'>
                  <div className='mt-5 p-3 border-sky-400 border-2' style={{ borderRadius: 10 }}>
                    <h4 className='text-xl'><b>Parcelamento</b> (Boleto)</h4>
                    <div className="grid grid-cols-2 w-full mt-5 justify-between">
                      <div className="ml-2 w-full">
                        <label htmlFor="pcc_valor_maximo_parcelas"><b>
                          Limite de parcelas </b>
                        </label>
                        <p className='text-xs font-bold'>
                          Número máximo de parcelas: 12x
                        </p>
                      </div>
                      <Controller
                        name="pcc_valor_maximo_parcelas"
                        control={control}
                        defaultValue={null}
                        rules={{ required: true }}
                        render={({ field: { ...props } }) => (
                          <InputNumber
                            {...props}
                            placeholder="ex: 2x"
                            onChange={e => props.onChange(e.value)}
                            pt={InputNumberPague}
                            locale="pt-BR"
                            mode="decimal"
                            suffix=' x'
                            min={0}
                            max={50}
                          />
                        )}
                      />
                    </div>

                    <div className="grid grid-cols-2 w-full mt-5 justify-between">
                      <div className="ml-2 w-full" style={{ marginRight: '-10px' }}>
                        <label htmlFor="pcc_valor_minimo_parcela"><b>
                          Valor mínimo das parcelas (em R$)</b>
                        </label>
                        <p className='text-xs font-bold'>
                          Menor valor possivel: R$ 30
                        </p>
                      </div>

                      <Controller
                        name="pcc_valor_minimo_parcela"
                        control={control}
                        defaultValue={null}
                        rules={{ required: true }}
                        render={({ field: { ...props } }) => (
                          <InputNumber
                            {...props}
                            placeholder="ex: R$ 150,00"
                            onChange={e => props.onChange(e.value)}
                            pt={InputNumberPague}
                            locale="pt-BR"
                            mode="currency"
                            currency='BRL'
                            min={1}
                          />
                        )}
                      />
                    </div>

                    <div className="w-full flex justify-center mt-5">
                      <div className="p-fluid w-full md:w-8/12 ">
                        <Button
                          pt={ButtonPagueDefault}
                          label="Salvar"
                          type="submit"
                        ></Button>
                      </div>
                    </div>
                  </div>
                </div>


                <Divider />
                <div className="mt-4 px-3">
                  <DataTable
                    value={providerInfo.parametros.parcelamento}
                    header={headerParcelamento}
                    pt={{
                      paginator: PaginatorPague
                    }}
                    onSelectionChange={(e) => HandleSelectionParcela(e.value)}
                    selectionMode="single"
                    className='config-tables'
                    emptyMessage="Nenhum parcelamento por faixa de valor cadastrado!"
                    paginator
                    rows={5}
                  >
                    <Column header="Valor Inicial" body={rowData => formatCurrency(Number(rowData.ppp_valor_inicial))} field="ppp_valor_inicial" />
                    <Column header="Valor Final" body={rowData => formatCurrency(Number(rowData.ppp_valor_final))} field="ppp_valor_final" />
                    <Column header="Nº Máx. de Parcelas" field="ppp_numero_parcelas" />
                  </DataTable>
                </div>
              </form>
            </div>
          </AppCard>
          <AppCard className="mt-4">
            <div className="grid w-full">
              <form onSubmit={handleSubmit(updateParams)}>
                <h4 className="text-xl"><b>Proposta</b></h4>

                <div className="px-3 w-full mt-4 grid gap-4">
                  <div className="grid-cols-3 grid w-full items-center">
                    <div className="w-full">
                      <label htmlFor="pcc_aceita_proposta"><b>Status</b></label>
                      <p>Ativa/Desativa a exibição e o aceite de proposta no app.</p>
                    </div>

                    <div className="w-full flex justify-between">
                      <Controller
                        name="pcc_aceita_proposta"
                        control={control}
                        defaultValue={false}
                        render={({ field: { value } }) => (
                          <Tag
                            className="transition-all duration-300 text-align-center w-full"
                            severity={value ? 'success' : 'danger'}
                            value={<p style={{ fontSize: '14px' }}>{value ? 'Ativo' : 'Inativo'}</p>}
                            rounded
                          />
                        )}
                      />
                    </div>

                    <div className="ml-4">
                      <Controller
                        name="pcc_aceita_proposta"
                        control={control}
                        defaultValue={false}
                        render={({ field: { value, onChange } }) => (
                          <InputSwitch
                            pt={{
                              slider: ({ props }) => ({
                                className: classNames(
                                  'absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent',
                                  'transition-colors duration-200 rounded-2xl',
                                  'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]',
                                  "before:absolute before:content-'' before:top-1/2 before:bg-white before:dark:bg-gray-900 before:w-5 before:h-5 before:left-1 before:-mt-2.5 before:rounded-full before:transition-duration-200",
                                  {
                                    'bg-gray-400 dark:bg-gray-200 hover:bg-gray-300 dark:hover:bg-gray-700 ': !props.checked,
                                    'bg-sky-400 before:transform before:translate-x-5': props.checked
                                  }
                                )
                              })
                            }}
                            checked={!!value}
                            onChange={(e) => onChange(e.value)}
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-2 mt-4">
                    <div>
                      <label htmlFor="pcc_proposta_closed"><b>Prazo para aceite da Contra-Proposta</b></label>
                      <p className="text-sm opacity-80">
                        Tempo para que a contra-proposta seja aceita. <b>Após o período, será encerrada automaticamente sem intervenção do devedor.</b>
                      </p>
                    </div>

                    <Controller
                      name="pcc_proposta_closed"
                      control={control}
                      defaultValue={5}
                      rules={{ required: true }}
                      render={({ field: { value, onChange } }) => (
                        <div className="flex flex-wrap justify-center gap-6 px-1">
                          <div className="flex items-center gap-2">
                            <RadioButton
                              inputId="pcc_proposta_closed_3"
                              value={3}
                              onChange={(e) => onChange(e.value)}
                              checked={Number(value) === 3}
                            />
                            <label htmlFor="pcc_proposta_closed_3">3 dias</label>
                          </div>
                          <div className="flex items-center gap-2">
                            <RadioButton
                              inputId="pcc_proposta_closed_5"
                              value={5}
                              onChange={(e) => onChange(e.value)}
                              checked={Number(value) === 5}
                            />
                            <label htmlFor="pcc_proposta_closed_5">5 dias</label>
                          </div>
                          <div className="flex items-center gap-2">
                            <RadioButton
                              inputId="pcc_proposta_closed_10"
                              value={10}
                              onChange={(e) => onChange(e.value)}
                              checked={Number(value) === 10}
                            />
                            <label htmlFor="pcc_proposta_closed_10">10 dias</label>
                          </div>
                        </div>
                      )}
                    />
                  </div>

                  <div className="w-full flex justify-center mt-2">
                    <div className="p-fluid w-full md:w-7/12">
                      <Button
                        pt={ButtonPagueDefault}
                        label="Salvar"
                        type="submit"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </AppCard>
        </div>
      </div>
    </div >
  );
}

export default Configuracoes;
